<div class="row">
    <div class="col-xs-2 col-sm-4 col-md-3 sm:hidden" *ngIf="image">
        <img width="160" [src]="image" alt="icon" />
    </div>
    <div class="col-xs-10 col-sm-8">
        <h2 class="text-l sm:hidden" *ngFor="let text of mainText">{{ text | translate }}</h2>
        <ng-container *ngIf="pending">
            <p *ngFor="let text of pendingText">{{ text | translate }}</p>
        </ng-container>
        <ng-container *ngIf="cancelled">
            <p *ngFor="let text of cancelledText">{{ text | translate }}</p>
        </ng-container>
        <h2 class="text-right">
            {{ 'dev.quickPurchase.Total' | translate }}
            <span>{{ total }}</span>
        </h2>
    </div>
</div>
<div class="row">
    <div class="col-xs-12 text-center sm:hidden" *ngIf="pending">
        <app-shared-ui-qrcode [code]="qr"></app-shared-ui-qrcode>
    </div>
</div>
